import React from "react";

import { PersonIcon } from "@/assets/images";

export const ChangeAccount = (props: {
  email: string;
  onClick(event: React.SyntheticEvent): void;
}) => {
  const { email, onClick } = props;
  return (
    <button
      className="mt-6 flex w-full flex-nowrap items-center justify-between gap-4 rounded-3xl bg-primary-wash px-[18px] py-2 text-xs font-semibold leading-6 text-primary-fg ring-offset-background hover:bg-primary/[0.07] focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 pointer-coarse:min-h-11"
      type="button"
      onClick={onClick}
    >
      <div className="flex items-center min-w-0 max-w-full">
        <PersonIcon className="flex-none mr-2" width={16} height={16} />
        <span className="block truncate text-muted-foreground" title={email}>
          {email}
        </span>
      </div>
      <span className="whitespace-nowrap">Change</span>
    </button>
  );
};
